import type { ActionDescriptor } from '@krp/client-runtime'
import { CASHIER_GROUPS_WINDOWS } from '../../cashier-groups/windows'
import { CASHIER_ANALYTICS_WINDOWS } from '../windows'

export const cashierAnalyticsActions: readonly ActionDescriptor[] = ([
  ['links', 'Связи кассиров', 'Открывает настройку связей записей одного человека из разных источников.', 'view'],
  ['reload', 'Обновить', 'Перечитывает кассиров и чеки источников, обновляет сохранённую сводку.', 'read-external'],
  ['filter', 'Отбор', 'Выбирает место продажи, часовой пояс и день или смену отчёта.', 'view'],
  ['original', 'Открыть чек', 'Открывает исходный чек с повторной проверкой доступа.', 'read'],
  ['page', 'Страница чеков', 'Показывает другую страницу общей ленты по тому же снимку данных.', 'read'],
  ['shift-sales', 'Продажи смены', 'Открывает вкладку «Продажи» на днях этой смены: итоги и чеки кассира за них.', 'view'],
] as const).map(([id, label, summary, effect]) => ({ id: `receipts.cashier-analytics.${id}`, label, summary, effect,
  windows: [CASHIER_ANALYTICS_WINDOWS.statistics, CASHIER_GROUPS_WINDOWS.report], evidence: {} }))
